exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".select-icon[data-v-2af2da2f]{margin-left:.42667rem;height:.96rem;line-height:.96rem;width:.96rem;text-align:center;color:#fff;font-size:18px;background-color:#e78081;border-radius:4px}", "", {"version":3,"sources":["/opt/build/repo/src/views/EditHistory.vue"],"names":[],"mappings":"AACA,8BACE,sBAAwB,AACxB,cAAgB,AAChB,mBAAqB,AACrB,aAAe,AACf,kBAAmB,AACnB,WAAY,AACZ,eAAgB,AAChB,yBAA0B,AAC1B,iBAAmB,CACpB","file":"EditHistory.vue","sourcesContent":["\n.select-icon[data-v-2af2da2f] {\n  margin-left: 0.42667rem;\n  height: 0.96rem;\n  line-height: 0.96rem;\n  width: 0.96rem;\n  text-align: center;\n  color: #fff;\n  font-size: 18px;\n  background-color: #e78081;\n  border-radius: 4px;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2af2da2f","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/EditHistory.vue
// module id = 226
// module chunks = 3